<template>
  <div class="menuBox flex fdcolmun">
    <div class="logoImgBox" @click="$fun.routerToPage('/')"></div>
    <div class="registerStep">
      <!-- 开启您的Rakumart之旅 -->
      <h1 class="stepTitleH1">{{ $fanyi("开启您的Rakumart之旅") }}</h1>
      <!-- :class="{ active: ops.step == 1 }" -->
      <div class="stepOpt flex active">
        <div class="iconBox">
          <img
            src="https://rakumart-test.oss-cn-hangzhou.aliyuncs.com/202409/66f24e2381897.svg"
            alt=""
          />
          <!-- <div class="verticalLine"></div> -->
        </div>
        <div class="fontBox">
          <div class="optTitle">{{ $fanyi("个人详细信息") }}</div>
          <div class="optCon">
            {{ $fanyi("输入您的个人信息") }}
          </div>
        </div>
      </div>
      <!-- <div class="stepOpt flex" :class="{ active: [2, 3].includes(ops.step) }">
        <div class="iconBox">
          <img
            src="https://rakumart-test.oss-cn-hangzhou.aliyuncs.com/202409/66f24e2082e8e.svg"
            alt=""
          />
          <div class="verticalLine"></div>
        </div>
        <div class="fontBox">
          <div class="optTitle">{{ $fanyi("校验") }}</div>
          <div class="optCon">
            {{ $fanyi("电子邮件，密码和电话") }}
          </div>
        </div>
      </div> -->
    </div>
    <div
      class="goBackBtn flex acenter"
      @click="ops.backLastPage"
      v-if="ops.step != 4"
    >
      <img
        src="https://rakumart-test.oss-cn-hangzhou.aliyuncs.com/202407/6683797671ecb.svg"
        alt=""
      />
      <span>{{ $fanyi("回退") }}</span>
    </div>
  </div>
</template>
<script>
import ops from "../utils/opStore.js";
export default {
  data() {
    return { ops };
  },
  components: {},
  computed: {},
  created() {},
  methods: {},
};
</script>
<style lang="scss" scoped="scoped">
@import "@/css/mixin.scss";
.menuBox {
  flex: 0 0 400px;
  min-height: 100vh;
  background: #f9fafb;
  box-shadow: 1px 0px 6px 0px rgba(0, 146, 70, 0.14);
  padding: 40px 43px;

  .logoImgBox {
    width: 184px;
    height: 49.73px;
    margin-bottom: 76px;
    cursor: pointer;
    background-image: url("https://rakumart-test.oss-cn-hangzhou.aliyuncs.com/202409/66f3ddaf42d73.svg");
    background-size: 100%;
  }
  .registerStep {
    .stepTitleH1 {
      margin: 0 0 46px;
      color: #013b2d;
      font-size: 18px;
      font-weight: 700;
      line-height: 28px;
    }
  }
  .stepOpt {
    margin-bottom: 8px;
    .iconBox {
      width: 48px;
      display: flex;
      flex-direction: column;
      align-items: center;
      margin-right: 16px;
      img {
        width: 48px;
        height: 48px;
        opacity: 0.5;
      }
      .verticalLine {
        margin: 4px 0;
        border-radius: 2px;
        background: var(--Gray-200, #eaecf0);
        width: 2px;
        flex: 1;
      }
    }
    .fontBox {
      min-height: 76px;
      color: #858c98;
      .optTitle {
        font-size: 16px;
        font-weight: 700;
        line-height: 24px;
        margin-bottom: 2px;
      }
      .optCon {
        font-size: 12px;
        font-weight: 400;
        line-height: 18px;
        padding-bottom: 32px;
      }
    }
  }
}
.active {
  .iconBox {
    img {
      opacity: 1 !important;
    }
  }
  .fontBox {
    color: #344054 !important;
  }
}

.goBackBtn {
  margin-top: auto;
  height: 24px;

  img {
    rotate: -90deg;
    width: 24px;
  }
  span {
    margin-left: 8px;
    color: var(--Gray-700, #344054);
    cursor: pointer;
    font-size: 16px;
    font-weight: 700;
    line-height: 24px;
  }
}
</style>
